// extracted by mini-css-extract-plugin
export var container = "navbar-module--container--be662";